<template>
    <fieldset class="form-item">
        <div class="form-flex">
            <label for="phoneNum" class="form-label form-label-required">휴대폰번호</label>
            <input type="tel" class="form-control" id="phoneNum" ref="phoneNum" placeholder="휴대폰번호를 입력해주세요" 
                 v-model="tempPhoneNum" @blur="confirmVaildPhoneNum" @keydown.stop="deleteCharacter" @keypress.enter.prevent="sendCertPhoneNum">
            <button type="button" class="btn-m" @click.prevent="sendCertPhoneNum" :disabled="isCertifiedPhoneNum"><strong>인증번호 발송</strong></button>
        </div>
        <div v-show="certPhoneNumTimer" class="form-flex position-relative form-time-limit" ref="phoneCert" id="form-time-limit-phoneNum">
            <label for="certNumPhoneNum" class="visually-hidden">휴대폰 인증코드</label>
            <input type="tel" class="form-control" ref="certNumPhoneNum" id="certNumPhoneNum" placeholder="인증코드 6자리 입력" 
                maxlength="6" v-model="certNumPhone" @keypress.enter.prevent="confirmCertMobile" :disabled="isCertifiedPhoneNum">
            <span class="cert-limit position-absolute" ref="certNumPhoneTimeLimit" id="cert-limit-phoneNum">{{certPhoneNumTimeLimitMinSec}}</span>
            <button class="btn-m btn-p" @click.prevent="confirmCertMobile" :disabled="isCertifiedPhoneNum"><strong>확인</strong></button>
        </div>
        <p v-show="tempMessagePhoneNum" class="form-info" :class="{'active': tempMessagePhoneNum, 'success': messageSuccess}">{{tempMessagePhoneNum}}</p>
    </fieldset>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props:{
        isConfirmAuth: {    // 회원정보 수정페이지 비밀번호 본인 인증여부
            type: Boolean,
            default: false
        },
        messagePhoneNum: {  // 유효성 검사 메시지 - 휴대폰번호 인증, (회원가입, 회원정보 수정 props)
            type: String,
            default: '',
        },
        phoneNum: {         // 휴대폰번호, (회원정보 수정 props)
            type: String,
        },
        oriPhoneNum: {         // 기존 인증된 휴대폰번호
            type: String,
        },
        authReqCode : {     // 인증요청 타입, (회원가입 props)
            type: String
        }
    },
    
    data() {
        return {
            tempPhoneNum: this.phoneNum,                 // 휴대폰번호
            isCertifiedPhoneNum: false,                  // 휴대폰 인증 여부
            certNumPhone: null,                          // 휴대폰 인증번호
            certPhoneNumTimer: null,                     // 휴대폰번호 인증 타이머
            certPhoneNumTimeLimit: 180,                  // 휴대폰 인증 제한 시간(3분)
            regExpMobile: /^(((01[16789]{1}[1-9]{1}[0-9]{2,3})|(010[2-9]{1}[0-9]{3}))[0-9]{4})$/, // 휴대폰번호 정규식
            messageSuccess: false,                       // 유효성 메시지 속성 - 성공
            tempMessagePhoneNum: this.messagePhoneNum,   // 휴대폰번호 인증 유효성 검사 메시지 - 임시
            // isCertifiedBtnDisabled : true                // 휴대폰번호 인증발송 버튼 disabled 상태 회원정보 수정 화면일 경우 기본값 : true
        }
    },

    computed: {
        ...mapState({
            authentication: state => state.authentication,
        }),

        // 휴대폰 인증번호 타임 리미트 동작시 인증 타이머 카운터 다운기능
        certPhoneNumTimeLimitMinSec() {
            return Math.floor(this.certPhoneNumTimeLimit / 60) + ':' + (this.certPhoneNumTimeLimit % 60 < 10 ? '0'+ this.certPhoneNumTimeLimit % 60 : this.certPhoneNumTimeLimit % 60);
        }
    },

    mounted(){        
        if(this.isConfirmAuth){ // 회원정보 수정시 비밀번호 본인 인증이 true 이면
            this.isCertifiedPhoneNum = true;
            this.sendValueToParent('', true);
        }else{
            // 컴포넌트 초기화
            this.sendValueToParent('', false);
            this.isCertifiedPhoneNum = false;
        }
    },

    watch: {
        tempPhoneNum() {
            // 회원정보수정 페이지 (패스워드 본인인증 여부가 확인됐을 때) && 기존 번호랑 입력값이 동일
            if(this.isConfirmAuth && (this.phoneNum === this.tempPhoneNum)){
                this.isCertifiedPhoneNum = true;
                this.$emit('updateIsCertifiedValues', {
                        isCertifiedPhoneNum: this.isCertifiedPhoneNum
                    }
                );
            }else{
                // 초기화
                this.isCertifiedPhoneNum = false;   // 휴대전화인증 false
                this.sendValueToParent('', false);
            }
        },
        
        messagePhoneNum(){
            this.tempMessagePhoneNum = this.messagePhoneNum;
        }
    },
    
    methods: {
        // 요소에 접근하여 포커싱하기
        focusOnWarning(element, className){
            element.focus();
            if(className === 'warning'){
                element.classList.add(className);
            }
        },

        // 부모 컴포넌트에 데이터 전달하기
        sendValueToParent(messageTxt, success){ // 가장 자주 전달이 필요한 안내 메시지만 매개변수로 설정
            this.messageSuccess = success;
            this.tempMessagePhoneNum = messageTxt;

            this.$emit('updatePhoneNumDatas', {
                'phoneNum': this.tempPhoneNum, 
                'isCertifiedPhoneNum': this.isCertifiedPhoneNum,
                // 'isCertifiedBtnDisabled' : this.isCertifiedBtnDisabled,
                'messagePhoneNum': this.tempMessagePhoneNum,
            });
        },

        // 문자 및 특수문자 제거
        deleteCharacter(){
            if(this.tempPhoneNum){
                this.tempPhoneNum = this.tempPhoneNum.replace(/[^\d]/ig, ""); // 하이픈(-) 제거
            }
            this.sendValueToParent();
            
            // 회원정보수정 페이지 (패스워드 본인인증 여부가 확인됐을 때) && 기존 번호랑 입력값이 동일
            if(this.isConfirmAuth && (this.phoneNum === this.tempPhoneNum)){
                this.isCertifiedPhoneNum = true;
                this.$emit('updateIsCertifiedValues', {
                        isCertifiedPhoneNum: this.isCertifiedPhoneNum
                    }
                );
            }else{
                // 초기화
                this.isCertifiedPhoneNum = false;   // 휴대전화인증 false
                this.sendValueToParent('', false);
            }
        },

        // 유효성검사
        confirmVaildPhoneNum(){
            if (!this.tempPhoneNum) {
                this.sendValueToParent('휴대폰번호를 입력해주세요.', false);
                return false;
            }
            if (!this.regExpMobile.test(this.tempPhoneNum)) {
                this.sendValueToParent('휴대폰번호를 양식에 맞게 입력해주세요.', false);
                return false;
            }
            return true;
        },
        
        // 인증번호 발송 버튼 클릭 : 휴대폰번호 유효성 검사 여부, 휴대폰번호 인증번호 발송 
        sendCertPhoneNum() {

            this.certNumPhone = ''; // 초기화

            // 유효성검사
            if (!this.confirmVaildPhoneNum()) {
                this.focusOnWarning(this.$refs.phoneNum, 'warning');
                return;
            }
            
            this.sendValueToParent('인증번호를 발송하고 있습니다. 잠시만 기다려주세요.', true);

            // 휴대폰번호 인증번호 발송
            this.dispatchSendAuthNo();
        },

        // 인증번호 확인 버튼 클릭: 휴대폰번호 인증번호 확인
        confirmCertMobile() {
            // 유효성 검사
            if (!this.certNumPhone) {
                this.focusOnWarning(this.$refs.certNumPhoneNum, 'warning');
                this.sendValueToParent('인증번호 6자리를 입력해주세요.', false);
                return;
            }

            // 인증번호 확인
            this.dispatchCheckAuthNo();
        },

         async dispatchSendAuthNo() {
            try {
                const data = {
                    authKey: this.tempPhoneNum,
                    authReqCode: this.authReqCode
                }

                await this.$store.dispatch(
                    'authStore/actionsCreateAuthNo',
                    data
                );

                /* 동일번호 재발송 오류메시지 이후에도 카운트다운은 기존대로 지속  */
                // 타이머가 있다면 초기화
                if (this.certPhoneNumTimer) {
                    clearInterval(this.certPhoneNumTimer);
                }
                // 타이머 제한시간 리셋
                this.certPhoneNumTimeLimit = 180;

                // 타이머 시작
                this.certPhoneNumTimer = setInterval(() => {
                    if (this.certPhoneNumTimeLimit > 0) {
                        this.certPhoneNumTimeLimit--;
                    } else {
                        clearInterval(this.certPhoneNumTimer);
                    }
                }, 1000);
                this.sendValueToParent('휴대폰번호 인증번호가 발송되었습니다.', true);
                return;

            } catch(err) {
                this.messageSuccess = false; // 초기화
                this.sendValueToParent(`${err.response.data.message}`, false);
                return;
            }
        },

        async dispatchCheckAuthNo() {
            try {
                const data = {
                    authKey: this.tempPhoneNum,
                    authNo: this.certNumPhone,
                    authReqCode: this.authReqCode
                }
                await this.$store.dispatch(
                    'authStore/actionsCheckAuthNo',
                    data
                );

                // 타이머 정지
                clearInterval(this.certPhoneNumTimer);
                
                // 타이머 초기화 & 인증번호 입력폼 숨김
                this.certPhoneNumTimer = null;

                // 인증여부 저장
                this.isCertifiedPhoneNum = true;
                // this.isCertifiedBtnDisabled = true;

                this.sendValueToParent('휴대폰번호 인증이 완료되었습니다.', true);
                return;

            } catch(err) {
                this.messageSuccess = false; // 초기화
                this.sendValueToParent(`${err.response.data.message}`, false);
                return;
            }
        }
    }
}
</script>

<style>
</style>